<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-in-front-of-every-silver-lining-19641977">
<h1 style="font-family:Arial; padding-top:200px">Part 1 <br/>In Front of Every Silver Lining <br/>1964–1977</h1>
<p>Y<em>ou cannot go back and change the beginning but you can start again from where you are and change the ending.</em></p><br/>
<p style="text-indent:0em">C S Lewis</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?12344be8